import clsx from "clsx";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { useChartState } from "@features/sales-v3/hooks/use-chart-state";
import { Switch } from "@shared/switch";

interface Props {
  chartIndex: number;
  disabled?: boolean;
}

export const ChartAlignAxesScaleToggle = ({
  chartIndex,
  disabled = false,
}: Props) => {
  const prettyLogEventPage = usePrettyLogEventPage();
  const { getChartAt, updateAlignAxes } = useChartState();
  const { alignAxesScale } = getChartAt(chartIndex);

  const setAlignAxes = () => {
    const newAlignAxes = !alignAxesScale;
    updateAlignAxes(chartIndex, newAlignAxes);
    prettyLogEventPage({
      domain: "Charts",
      action: "onClick",
      additionalActionInfo: "Change Chart Align Axes Scale",
      data: {
        alignAxesScale: newAlignAxes,
      },
    });
  };

  return (
    <div className="flex flex-col justify-between items-start">
      <div
        className={clsx("font-bold text-xs mb-0.5", { "opacity-60": disabled })}
      >
        ALIGN AXES
      </div>
      <div className="h-[34px] flex-horizontal-center">
        <Switch
          id={`align-axis-${chartIndex}`}
          size="medium"
          disabled={disabled}
          onChange={setAlignAxes}
          value={alignAxesScale}
        />
      </div>
    </div>
  );
};
